var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HznTextLink_instances, _HznTextLink_iconSize;
import { LitElement, html } from '@horizon/base';
import { property, query } from '@horizon/base/decorators.js';
import { classMap, ifDefined } from '@horizon/base/directives.js';
import { nothing } from '@horizon/base/html.js';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { HznIconExternalLink } from '@horizon/icons/individual';
import TextLinkStyles from './text-link.css.js';
/**
 *
 * @tag hzn-text-link
 * @tagname hzn-text-link
 * @summary A link component for adding text-links within text tags or by themselves
 *
 * @fires {Event} click - Emitted when the text-link is clicked
 */
export class HznTextLink extends ScopedElementsMixin(LitElement) {
    constructor() {
        super(...arguments);
        _HznTextLink_instances.add(this);
        /**
         * Sets the href of the contained anchor tag
         */
        this.href = '';
        /**
         * Sets the tag to inline-block or block - for use when contained in text tags
         */
        this.block = false;
        /**
         * Turns off underlining for text content within contained anchor tag
         */
        this.noUnderline = false;
        /**
         * Sets the tone/color of text within anchor tag
         */
        this.tone = 'interactive';
        /**
         * Sets the font size of text within anchor tag
         */
        this.size = 'base';
        /**
         * Sets the font weight of text within anchor tag
         */
        this.weight = 'base';
        /**
         * Sets the text-align of text along the x-axis
         */
        this.align = 'left';
    }
    static get scopedElements() {
        return { 'hzn-icon-external-link': HznIconExternalLink };
    }
    /**
     * Simulates a click on the button
     */
    click() {
        if (this.innerAnchor) {
            this.innerAnchor.click();
        }
    }
    render() {
        const sizeClasses = {
            'hzn-text-link': true,
            small: Boolean(this.block && this.size === 'small'),
            base: Boolean(this.block && this.size === 'base'),
            large: Boolean(this.block && this.size === 'large'),
            caption: Boolean(this.block && this.size === 'caption'),
            callout: Boolean(this.block && this.size === 'callout'),
        };
        // DO NOT ADD WHITE SPACE OR NEW LINES IN THIS RENDER TEMPLATE
        // hzn-text-links can be `display: inline` so the whitespace in the render template influences the visual render.
        // therefore, there cannot be any whitespace in the render template
        return html `<a
      href="${this.href}"
      rel=${ifDefined(this.rel ? `${this.rel}` : ifDefined(this.target ? 'noreferrer noopener' : undefined))}
      target=${ifDefined(this.target)}
      download=${ifDefined(this.download)}
      title=${ifDefined(this.title)}
      aria-label=${ifDefined(this.ariaLabel)}
      class="${classMap(sizeClasses)}"
      ><slot></slot>${this.target ? html `<span class="visually-hidden">. opens in a new window.</span>` : nothing}${this
            .external
            ? html `<hzn-icon-external-link size="${__classPrivateFieldGet(this, _HznTextLink_instances, "m", _HznTextLink_iconSize).call(this)}"></hzn-icon-external-link>`
            : nothing}</a
    >`;
    }
}
_HznTextLink_instances = new WeakSet(), _HznTextLink_iconSize = function _HznTextLink_iconSize() {
    if (this.size === 'callout' && this.block) {
        return 'large';
    }
    else if (this.size === 'large' && this.block) {
        return 'base';
    }
    else {
        return 'small';
    }
};
HznTextLink.styles = [TextLinkStyles];
HznTextLink.shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
__decorate([
    query('a')
], HznTextLink.prototype, "innerAnchor", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "href", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "rel", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "target", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "download", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznTextLink.prototype, "external", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznTextLink.prototype, "block", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'no-underline' })
], HznTextLink.prototype, "noUnderline", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "tone", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "weight", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "align", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznTextLink.prototype, "on", void 0);
__decorate([
    property({ type: String, attribute: 'hzn-aria-label' })
], HznTextLink.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: String, attribute: 'hzn-title' })
], HznTextLink.prototype, "title", void 0);
//# sourceMappingURL=text-link.js.map